<div
  class="chat-answer"
  (mouseenter)="toggleHover(true)"
  (mouseleave)="toggleHover(false)"
  [class.active-menu]="isAnyActionOpen() || isFeedbackOpen"
  [class.active-popup]="resourcePopupActiveIndex"
>
  <div class="assistant-icon-header">
    <assistant-icon
      [model]="assistantData"
      [displayBorder]="false"
      [spriteEmojiSize]="isExtension ? 16 : 24"
      [iconStyles]="isExtension ? assistantIcon : assistantIconExtension"
    ></assistant-icon>
    @if (isExtension) {
      <div class="assistant-name">{{ assistantData.name }}</div>
    }
  </div>
  <div #chatAnswer class="content">
    <div
      class="answer-text"
      customResourcePanel
      [resources]="resources"
      [typing]="typing()"
      [viewMode]="viewMode"
      (completeRender)="onTypedComplete()"
      [isResourceLookup]="message.intent === 'ResourceLookup'"
    >
      <u-typing-typography #answerText [viewMode]="viewMode" [text]="textContent" (typingFinished)="onTypingFinished()">
      </u-typing-typography>
      @if (showSearchId) {
        <div style="word-break: break-all">
          <strong>SearchId: </strong><a (click)="openSearchLog(searchId)">{{ searchId }}</a>
        </div>
        <div><strong>ChatId:</strong> {{ chatId }}</div>
      }
    </div>
    @if (isAnswerResultsAvailable && (viewMode === 'static' || isLoadingAnswer)) {
      <div class="chat-answer-footer" #footerAnswer>
        @if (message.intent !== 'ResourceLookup') {
          <short-result-resources
            [resources]="resources"
            [sessionId]="sessionId"
            [searchId]="searchId"
            [showResourcesNumbers]="message.intent !== 'People' && message.references?.length"
            [resourceActiveIndex]="resourcePopupActiveIndex"
          ></short-result-resources>
        }
        <answer-actions
          [model]="{
            answer: message.content,
            questionQuery: questionQuery,
            formattedAnswer: textContent,
            resources: resources,
            answerIntent: message.intent,
          }"
          [searchId]="searchId"
          [active]="isHovered || resourcePopupActiveIndex"
          [displayFeedbackAction]="assistantData?.knowledgeType !== 'External' && assistantData.state === 'enabled'"
          [isFeedbackOpen]="isFeedbackOpen"
          (feedbackShow)="onShowFeedback($event)"
          (actionClosed)="isAnyActionOpen.set(false)"
        ></answer-actions>
      </div>
    }
  </div>
</div>
